import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    adminUserDetails: {}, // FIX typo: "Detials" → "Details"
};

export const adminUserDetailsSlice = createSlice({
    name: "adminUserDetails",
    initialState,
    reducers: {
        setAdminUserDetails: (state, action) => {
            state.adminUserDetails = action.payload;
        },
        clearAdminUserDetails: (state) => {
            state.adminUserDetails = {};
        },
    },
});

export const {setAdminUserDetails, clearAdminUserDetails} = adminUserDetailsSlice.actions;
export default adminUserDetailsSlice.reducer;
